import {useTranslation} from '@aboutyou/i18n';
import {COLORS, GenericIconName, Icon, Text} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {useGetCouponsCount} from '../../../features/Coupons/CouponWallet/hooks/useGetCouponsCount';
import {useShowNewCouponsNotificationBadge} from '../../../features/Coupons/CouponWallet/hooks/useShowNewCouponsNotificationBadge';
import {useTrackCouponWalletEntryPoint} from '../../../features/Coupons/CouponWallet/hooks/useTrackCouponWalletEntryPoint';
import {useWalletStateManager} from '../../Wallet/utils/useWalletStateManager';
import {IconContainer, OffcanvasButton} from './OffcanvasHeaderComponents';
// eslint-disable-next-line monorepo/no-internal-import
import {WithBadge} from '@aboutyou/ui-components/src/components/atoms/Badge/WithBadge';

export const OffcanvasHeaderCouponWalletButton: FC<{badgeColor?: string}> = ({
  badgeColor,
}) => {
  const {t} = useTranslation();
  const couponsCount = useGetCouponsCount();
  const {showNewCouponsNotificationBadge, setCouponWalletWasOpened} =
    useShowNewCouponsNotificationBadge(couponsCount);
  const {open} = useWalletStateManager();
  const {featureImpressionRef, trackFeatureClick} =
    useTrackCouponWalletEntryPoint();

  const handleOnCouponWalletButtonClick = () => {
    trackFeatureClick();
    open('coupons');
    setCouponWalletWasOpened();
  };

  return (
    <OffcanvasButton
      data-testid="OffcanvasToCouponWallet"
      onClick={handleOnCouponWalletButtonClick}
      ref={featureImpressionRef}
      aria-label={t('Open the coupon wallet')}
    >
      <IconContainer>
        <WithBadge
          variant="rounded"
          offset={{
            top: 2,
            right: 0,
          }}
          badgeSize={7}
          displayBadgeWithoutCount={showNewCouponsNotificationBadge}
          badgeColor={badgeColor || COLORS.Red}
        >
          <Icon
            data-testid="couponIcon"
            asset={GenericIconName.Coupon}
            fill={COLORS.Black}
            size="S"
          />
        </WithBadge>
        {showNewCouponsNotificationBadge && (
          <Text data-testid="couponsCount" size="px9" weight="mediumHeavy">
            {couponsCount}
          </Text>
        )}
      </IconContainer>
    </OffcanvasButton>
  );
};
